import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IUserAddress } from 'src/modules/authentication/interfaces/user-address.interface';
import { HomecarePatient } from '../../interfaces/homecare-patient.interface';
import { NewPatientFormComponent } from '../new-patient-form/new-patient-form.component';
import { ShiftPatientComponent } from '../shift-patient/shift-patient.component';

@Component({
  selector: 'app-single-patient-shift-selection',
  templateUrl: './single-patient-shift-selection.component.html',
  styleUrls: ['./single-patient-shift-selection.component.scss'],
})
export class SinglePatientShiftSelectionComponent implements OnInit {

  @Input() entityId: string;
  @Input() availablePatients: HomecarePatient[] = [];
  @Input() currentView?: string;
  @Output() onPatientChange: EventEmitter<HomecarePatient> = new EventEmitter();
  @ViewChild(ShiftPatientComponent) shiftPatientComponent!: ShiftPatientComponent;


  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    console.log('currentView', this.currentView);
  }

  handlePatientChange(data){
    this.onPatientChange.emit(data);
  }


  async showNewPatientForm(){
    const patientModal = await this.modalController.create({
      component: NewPatientFormComponent,
      cssClass: 'patientsModal',
      backdropDismiss: true,
      componentProps: {
        entityId: this.entityId,
        addPatientAddress: (newPatient: {id: string, address: IUserAddress}) => {
          this.availablePatients.push(newPatient);
        }
      }
    });

    patientModal.present();
  }

  resetShiftPatient() {
    this.shiftPatientComponent.reset();
  }

}
